/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Popover,
  Button,
  Modal,
  Spin,
  Space,
  Select,
  Row,
  Popconfirm,
  Divider,
  message,
  Checkbox,
  InputNumber,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  getAllProjects,
  createProject,
  deleteProject,
  updateProject,
  publishedProject,
} from "../Actions/projectsAction";
import { PermissionWrapper } from "../components/PermissionWrapper";
import MyTable from "../components/table";
import "./styles/clients.css";
import { ViewCommercialProjects } from "../pages/ViewCommercialProjects";
import { UpdateCommercialProjects } from "../pages/updateCommercialProjects";
import { useBreakpoints } from "../components/ResponsiveBreakPoints";
import useColumnSearch from "../Utils/useColumnSearch";
const schema = Yup.object().shape({
  property_name: Yup.string().required("Required"),
  tag_line: Yup.string().required("Required"),
  builder: Yup.string().required("Required"),
  no_of_floor: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Required"),
  possesion: Yup.string().required("Required"),
  // parking: yup.string().required("Required"),
});
const { Text, Title } = Typography;

const CommercialProjects = () => {
  const dispatch = useDispatch();
  const { isMobile } = useBreakpoints();
  const {
    projects,
    isGetProjectsLoading,
    isCreateProjectLoading,
    isUpdateProjectLoading,
    isDeleteProjectLoading,
  } = useSelector((state) => {
    const {
      projects,
      isGetProjectsLoading,
      isCreateProjectLoading,
      isUpdateProjectLoading,
      isDeleteProjectLoading,
    } = state.projects;
    return {
      projects,
      isGetProjectsLoading,
      isCreateProjectLoading,
      isUpdateProjectLoading,
      isDeleteProjectLoading,
    };
  });
  useEffect(() => {
    dispatch(getAllProjects("type=Commercial"));
  }, []);
  const { register, handleSubmit, errors, clearErrors, control, reset } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues: { pre_lease: false, pre_launch: false, is_sell: false },
      mode: "onChange",
    });
  const [files, setFiles] = useState([]);
  const [name, setName] = useState("");
  const [createDialog, setCreateDialog] = useState(false);
  const [brochurePdf, setBrochurePdf] = useState(null);
  const pdfInputRef = useRef(null);
  const [description, setDescription] = useState([
    { key: "", value: "", id: Math.random() },
  ]);
  const handleResetForm = () => {
    setDescription([...description, { key: "", value: "" }]);
  };
  const handleCreateProject = (data, type, event) => {
    // event.preventDefault();
    data.parking = 0;
    data.image_url = files.length > 0 ? files : null;
    data.project_pdf = brochurePdf ? brochurePdf : null;
    data.project_type = "Commercial";
    data.description = { description };
    dispatch(
      createProject(
        data,
        "type=Commercial",
        successCreateArea,
        failureCreateArea,
      ),
    );
  };

  const successCreateArea = () => {
    setFiles([]);
    setName("");
    setBrochurePdf(null);
    setDescription([{ key: "", value: "" }]);
    setCreateDialog(false);
    reset({
      property_name: "",
      no_of_floor: "",
      area_name: "",
      image_url: "",
      builder: "",
      tag_line: "",
      possesion: "",
      bhk: "",
      price_range: "",
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_sequence: "",
    });
    setTimeout(() => {
      message.success("You have successfully create commercial project.");
    }, 2000);
  };
  const failureCreateArea = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    setCreateDialog(false);
    reset();
  };
  const handleAdd = () => {
    const newDescription = description.concat([
      { key: "", value: "", id: Math.random() },
    ]);
    setDescription(newDescription);
  };
  const handleRemove = (id) => {
    const newDescription = description.filter((x) => x.id !== id);
    setDescription(newDescription);
  };
  const handleOnChange = (e, index) => {
    const { name, value } = e.target;
    const newDescription = description;
    const selectedObject = newDescription[index];
    selectedObject[name] = value;
    setDescription(newDescription);
  };
  const handleCancel = () => {
    reset({
      property_name: "",
      no_of_floor: "",
      area_name: "",
      image_url: "",
      builder: "",
      tag_line: "",
      possesion: "",
      bhk: "",
      price_range: "",
      pre_lease: false,
      pre_launch: false,
      is_sell: false,
      new_sequence: "",
    });
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
    setBrochurePdf(null);
    setFiles([]);
    setName("");
    clearErrors();
    setDescription([{ key: "", value: "" }]);
    setCreateDialog(false);
  };
  const handleImageChange = (event) => {
    const { value } = event.target;
    const files = Array.from(event.target.files);
    setName(value);
    setFiles(files);
  };

  return (
    <Spin
      spinning={
        isGetProjectsLoading ||
        isCreateProjectLoading ||
        isUpdateProjectLoading ||
        isDeleteProjectLoading
      }
      // spinning={false}
    >
      <Modal
        title="Create Commercial Project"
        open={createDialog}
        onCancel={() => handleCancel()}
        footer={null}
        maskClosable={false}
      >
        <form onSubmit={handleSubmit(handleCreateProject)}>
          <Row gutter={[8, 16]}>
            {/* <Col>
            {files.length > 0 && (
            <img
              // className="pCardImage"
              alt=""
              src={URL.createObjectURL(files[0])}
              width='100px'
              height={100}
            />
          )}</Col> */}
            {files.length > 0 &&
              files?.map((image, index) => (
                <div key={index} style={{ margin: "10px" }}>
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`image-${index}`}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ))}
            <Col>
              <input
                name="image_url"
                value={name}
                onChange={(e) => handleImageChange(e)}
                multiple
                type="file"
              ></input>
            </Col>
            <Col span={24}>
              <Row>
                <Text>Upload Brochure (PDF)</Text>
              </Row>

              <input
                ref={pdfInputRef}
                type="file"
                accept="application/pdf"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file && file.type === "application/pdf") {
                    setBrochurePdf(file);
                  } else {
                    message.error("Please upload a valid PDF file");
                    e.target.value = "";
                  }
                }}
              />
            </Col>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Project Name</Text>
              </Row>
              <Controller
                as={Input}
                name="property_name"
                control={control}
                placeholder="Property Name."
              />
              {errors.property_name && (
                <span className="error_style">Property Name is required</span>
              )}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Builder</Text>
              </Row>
              <Controller
                as={Input}
                name="builder"
                control={control}
                placeholder="Builder"
              />
              {errors.builder && (
                <span className="error_style">Builder is required</span>
              )}
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>No of Storey</Text>
              </Row>
              <Controller
                as={Input}
                name="no_of_floor"
                control={control}
                placeholder="No of Storey"
              />
              {errors.no_of_floor && (
                <span className="error_style">No of Storey is required</span>
              )}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Area</Text>
              </Row>
              <Controller
                as={Input}
                name="area_name"
                control={control}
                placeholder="Enter area"
              />
              {errors.area_name && (
                <span className="error_style">Area is required</span>
              )}
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Tag Line</Text>
              </Row>
              <Controller
                as={Input}
                name="tag_line"
                control={control}
                placeholder="Tag Line"
              />
              {errors.tag_line && (
                <span className="error_style">Tag Line is required</span>
              )}
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Possesion</Text>
              </Row>
              <Controller
                as={Input}
                name="possesion"
                control={control}
                placeholder="Possesion"
              />
              {errors.possesion && (
                <span className="error_style">possesion is required</span>
              )}
            </Col>

            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>BHK</Text>
              </Row>
              <Controller
                as={Input}
                name="bhk"
                control={control}
                placeholder="Enter BHK"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Price Range</Text>
              </Row>
              <Controller
                as={Input}
                name="price_range"
                control={control}
                placeholder="Enter Price Range 1cr - 5cr"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Total Units</Text>
              </Row>
              <Controller
                as={Input}
                name="total_units"
                control={control}
                placeholder="Enter total units"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Sequence</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="new_sequence"
                control={control}
                placeholder="Enter sequence"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Latitude</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="latitude"
                control={control}
                placeholder="Enter Latitude"
              />
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Row>
                <Text>Longitude</Text>
              </Row>
              <Controller
                as={<InputNumber style={{ width: "100%" }} />}
                name="longitude"
                control={control}
                placeholder="Enter Longitude"
              />
            </Col>

            {/* Changed Pre launch to New and For sale to Resell  */}
            <Col>
              <Row gutter={[30, 0]}>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>New</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="pre_launch"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>Resell</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="is_sell"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            defaultValue={false}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row gutter={[10, 0]}>
                    <Col>
                      <Text>Pre Lease</Text>
                    </Col>
                    <Col>
                      <Controller
                        name="pre_lease"
                        control={control}
                        render={(props) => (
                          <Checkbox
                            {...props}
                            checked={props.value}
                            onChange={(e) => props.onChange(e.target.checked)}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Button onClick={handleAdd} type="primary" icon={<PlusOutlined />}>
              Add
            </Button>
          </Row>

          {description.map((des, index) => {
            return (
              <Row key={index} gutter={[8, 16]}>
                <Col span={24}></Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Row>
                    <Text>Key</Text>
                  </Row>
                  <Input
                    key={des.id}
                    name={`key`}
                    onChange={(e) => handleOnChange(e, index)}
                    placeholder="e.g. Showroom, Shopes Offices"
                  />
                  {/* {errors.description && (
                  <span className="error_style">Type Of BHK is required</span>
                )} */}
                </Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Row>
                    <Text>value</Text>
                  </Row>
                  <Input
                    key={des.id}
                    name={`value`}
                    onChange={(e) => handleOnChange(e, index)}
                    placeholder="e.g. 2500.Sqft"
                  />
                  {/* {errors.description && (
                  <span className="error_style">Type Of BHK is required</span>
                )} */}
                </Col>
                {index !== 0 && (
                  <Button type="link" onClick={() => handleRemove(des.id)}>
                    Remove
                  </Button>
                )}
              </Row>
            );
          })}

          <Row justify="end" gutter={[0, 16]}>
            <Col span={24}></Col>
            <Col>
              {isCreateProjectLoading ? (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                      }}
                      spin
                    />
                  }
                />
              ) : (
                <Button type="primary" htmlType="submit">
                  Create Commercial Project
                </Button>
              )}
            </Col>
          </Row>
        </form>
      </Modal>
      {projects && (
        <AllCommercialProjects
          data={projects}
          handleDialog={() => setCreateDialog(true)}
        />
      )}
      {/* {projects && <AllProperties data={projects} />} */}
    </Spin>
  );
};
export default CommercialProjects;

const AllCommercialProjects = (props) => {
  const { getColumnSearchProps } = useColumnSearch();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.users);
  const isAdmin = currentUser?.role === "Admin";
  const { handleDialog } = props;
  const [showSearch, setShowSearch] = useState(false);
  const [currentProject, setCurrentProject] = useState({});
  const onRowSelect = (record) => {
    setCurrentProject(record);
    setShowSearch(true);
  };
  // useEffect(() => {
  //   if (createProject !== {}) {
  //     // dispatch() getTasks
  //     // dispatch() getSearch Properies
  //   }
  // }, [currentProject]);

  const columns = () => [
    {
      title: "Project Name",
      width: 120,
      dataIndex: "property_name",
      key: "1",
      // fixed: "left",
    },
    {
      title: "Project Type",
      key: "status",
      width: 120,

      filters: [
        { text: "New", value: "pre_launch" },
        { text: "Resell", value: "is_sell" },
        { text: "Pre lease", value: "pre_lease" },
      ],

      onFilter: (value, record) => {
        return record?.[value] === true;
      },

      render: (record, row) => {
        return (
          <div>
            {row.pre_launch && <span>New&nbsp;</span>}
            {row.is_sell && <span>Resell</span>}
            {row.pre_lease && <span>Pre Lease&nbsp;</span>}
          </div>
        );
      },
    },
    {
      title: "Sequence",
      width: 80,
      dataIndex: "new_sequence",
      render: (record) => {
        return <div>{record || "-"}</div>;
      },
    },
    {
      title: "Tag Line",
      width: 150,
      dataIndex: "tag_line",
      key: "2",
      // fixed: "left",
    },
    {
      title: "Builder",
      width: 100,
      dataIndex: "builder",
      key: "3",
      // fixed: "left",
    },
    {
      title: "No Of Storey",
      width: 80,
      dataIndex: "no_of_floor",
      key: "4",
      // fixed: "left",
    },
    {
      title: "Possesion",
      dataIndex: "possesion",
      key: "5",
      width: 100,
    },
    // {
    //   title: "Parking",
    //   dataIndex: "parking",
    //   key: "4",
    //   // width: 150,
    // },
    {
      title: "Area",
      dataIndex: "area_name",
      key: "6",
      width: 100,
      render: (record, object) => {
        return <div>{record}</div>;
      },
    },
    {
      title: "id",
      width: 90,
      dataIndex: "id",
      key: "7",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id) => (
        <ActionComponent
          id={id}
          type="type=Commercial"
          published={currentProject.published}
        />
      ),
    },
  ];
  return (
    <>
      <Row className="rowWithPadding" justify="space-between">
        <Col>
          <Title level={4}>All Commercial Projects({props.data.length})</Title>
        </Col>
        <Col>
          <PermissionWrapper
            resource="projects_commercial"
            action="create"
            disabled={true}
          >
            <Button type="primary" onClick={() => handleDialog()}>
              Create Commercial Project
            </Button>
          </PermissionWrapper>
        </Col>
      </Row>
      <MyTable
        columns={columns()}
        data={props.data}
        onRowSelect={(record) => onRowSelect(record)}
      />
    </>
  );
};
const ActionComponent = ({ id, type, published }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.users);
  const isAdmin = currentUser?.role === "Admin";
  const handleDeleteCommercialProject = (project_id) => {
    project_id = id;
    dispatch(
      deleteProject(
        project_id,
        "type=Commercial",
        successDeleteCommercialProject,
        failureDeleteCommercialProject,
      ),
    );
  };

  const successDeleteCommercialProject = () => {
    // setCreateDialog(false);
    setTimeout(() => {
      message.success("You have successfully delete commercial project.");
    }, 2000);
  };
  const failureDeleteCommercialProject = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
  };
  const handleUpdatePublished = () => {
    // event.preventDefault();
    setPopoverVisible(false);
    dispatch(publishedProject(id, type, true));
  };
  const handleUpdateUnPublished = () => {
    // event.preventDefault();
    setPopoverVisible(false);
    dispatch(publishedProject(id, type, false));
  };
  const content = (
    <div>
      {/* <ViewProperty id={id} />
      &nbsp;&nbsp; */}
      {/* <UpdateProperty id={id} />
      &nbsp;&nbsp; */}
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_commercial"
        action="show"
        disabled={true}
      >
        <ViewCommercialProjects id={id} setPopoverVisible={setPopoverVisible} />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_commercial"
        action="update"
        disabled={true}
      >
        {published ? (
          <Button type="link" onClick={() => handleUpdateUnPublished()}>
            Un Published
          </Button>
        ) : (
          <Button type="link" onClick={() => handleUpdatePublished()}>
            Published
          </Button>
        )}
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_commercial"
        action="update"
        disabled={true}
      >
        <UpdateCommercialProjects
          id={id}
          setPopoverVisible={setPopoverVisible}
        />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper
        resource="projects_commercial"
        action="destroy"
        disabled={true}
      >
        <Popconfirm
          title="Sure to delete?"
          // onConfirm={() => dispatch(deleteProject(id, type))}
          onConfirm={() => handleDeleteCommercialProject(id, type)}
        >
          <Button type="link" onClick={() => setPopoverVisible(false)}>
            Delete
          </Button>
        </Popconfirm>
      </PermissionWrapper>
    </div>
  );
  return (
    <Popover
      content={content}
      open={popoverVisible}
      trigger="click"
      onOpenChange={setPopoverVisible}
    >
      <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
        Action
      </Button>
    </Popover>
  );
};
